import { getLanguage } from '@dvb/common';
import { authAxios, externalAxios } from '@school-manage/api/client';

import type { Banner, SportsRes } from './app.types';

const baseUrl = import.meta.env.VITE_APP_APP_SERVICE_BASE_URL;

export const getSportsRequest = async () => {
  const { data } = await externalAxios.get<SportsRes>(
    `${baseUrl}/${getLanguage()}/sports`
  );
  return data;
};

export const getBannersRequest = async () => {
  const { data } = await authAxios.get<Banner[]>('/api/v1/banner/list');
  return data;
};
